export default __webpack_public_path__ + "static/media/index.78492f0a.less";